import React, { useEffect, useState } from 'react';
import { ExtendedContentContainer, ExtendedContentType } from 'components/ExtendedContent/ExtendedContentContainer';
import { useStore, StoreTypes } from 'context';
import { ExtensionType } from 'constants/wordGrid';
import Repository from 'repositories/Repository';
import { WordGridSubContentPanel } from './wordGridSubContent/WordGridSubContentPanel';

const { ExtendedResourceRepository } = Repository;

// 課文下方「形音辨析」icon 直接開啟時，改用新版生字庫 subcontent 面板呈現「字音字形」。
const WordGlyphPanel = ({ wordGridResource, defaultWord }) => {
  const [{ bookId, books }] = useStore(StoreTypes.books);
  const book = books.find(info => info.bookId === bookId);
  const isElementaryHighGrade = !!book && (
    book.display_name.includes('國小國語5') || book.display_name.includes('國小國語6')
  );

  const [allWords, setAllWords] = useState([]);

  // wordGridResource 每筆只有 .Path（生字 JSON 未載入），此處載入後建構 glyphSet 的 allWords。
  useEffect(() => {
    let cancelled = false;
    (async () => {
      const list = await Promise.all(
        (wordGridResource || []).map(w =>
          ExtendedResourceRepository.getJSONContent({ bookId, pathName: w.Path })
        )
      );
      if (cancelled) return;
      const built = list
        .filter(i => i && Array.isArray(i.GlyphSet) && i.GlyphSet.length > 0)
        .map(i => ({
          word: i.Name,
          extensionData: { meaningSet: [], wordsSet: [], idiomSet: [], glyphSet: i.GlyphSet },
        }));
      setAllWords(built);
    })();
    return () => { cancelled = true; };
  }, [bookId, wordGridResource]);

  return (
    <WordGridSubContentPanel
      allWords={allWords}
      bookId={bookId}
      initialWord={defaultWord}
      initialExtensionType={ExtensionType.GlyphSet}
      isElementaryHighGrade={isElementaryHighGrade}
    />
  );
};

export const WordGlyphModalComponent = ({ wordGridResource, defaultWord }) => {
  return (
    <ExtendedContentContainer extendedContentType={ExtendedContentType.WordGridSubContent}>
      <WordGlyphPanel wordGridResource={wordGridResource} defaultWord={defaultWord} />
    </ExtendedContentContainer>
  );
};
